import { InjectionToken } from '@angular/core';

/**
 * Bridge to AngularJS `$window` (window global).
 *
 * Used by HelpersService, CheckoutProcessService, and others that need
 * access to browser globals. When consumers migrate to Angular 18,
 * inject the native `window` object directly via DOCUMENT token or
 * use Angular's platform-agnostic APIs.
 */
export interface IWindowPort {
  document: Document;
  location: Location;
  navigator: Navigator;
  localStorage: Storage;
  sessionStorage: Storage;
  alert(message?: string): void;
  confirm(message?: string): boolean;
  setTimeout: typeof setTimeout;
  setInterval: typeof setInterval;
  clearTimeout: typeof clearTimeout;
  clearInterval: typeof clearInterval;
  [key: string]: any;
}

export const WINDOW_PORT = new InjectionToken<IWindowPort>('WINDOW_PORT');
